import { IPackageListingAppBaseText, defaultBaseText } from "../../classes/package-listing-text";

/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
interface IPackageListingCustomText {
    genreFilterDefaultValue: string;
    availabilityFilterDefaultValue: string;
    renewalCurrentSubscriptionPreTitleText: string;
    packageSecondChoiceMessaging: string;
    packageSecondChoiceLabel: string;
}


let customText: IPackageListingCustomText = {
    genreFilterDefaultValue: "",
    availabilityFilterDefaultValue: "",
    renewalCurrentSubscriptionPreTitleText: "",
    packageSecondChoiceMessaging: "",
    packageSecondChoiceLabel: ""
}

export type IPackageListingAppText = IPackageListingCustomText & IPackageListingAppBaseText;
export const defaultText: IPackageListingAppText = { ...defaultBaseText, ...customText };